import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import {OauthService} from './oauth.service';
import {App} from 'ionic-angular';
import {Http} from '@angular/http';
import {ToolsService} from './tools.service';
import {AppProvider} from "../../core/app/app-provider.service";

@Injectable()
export class ImagesService extends OauthService {
  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
  ) {
    super(http, app, appProvider, tools);
  }

  getImage(id: number, images: Array<any> = null, type: string, typeImage: string = null) {
    const currentImage = images ? images.find(img => img.type === typeImage) : true;
    if (currentImage) {
      switch (type) {
        case 'activite':
          return this.Routing.generate('api_get_activite_image', {
            '_format': 'json',
            activite: id,
            image: currentImage.id
          }, true);

        case 'famille':
          return this.Routing.generate('api_get_famille-produit_image', {
            '_format': 'json',
            familleProduit: id,
            image: currentImage.id
          }, true);

        case 'produit':
          return this.Routing.generate('api_get_produit_image', {
            '_format': 'json',
            produit: id,
            image: currentImage.id
          }, true);

        case 'article':
          return this.Routing.generate('api_get_article_image', {
            '_format': 'json',
            article: id,
            image: currentImage.id
          }, true);
        case 'blogArticle':
          return this.Routing.generate('api_get_blog-articles_image', {
            '_format': 'json',
            blogArticle: id,
            image: currentImage.id
          }, true);
        case 'beneficiaire':
          return this.Routing.generate('api_get_beneficiaire_photo', {
            '_format': 'json',
            'beneficiaire': id,
          }, true);
        case 'sondage':
          return this.Routing.generate('api_get_sondage_image', {
            '_format': 'json',
            sondage: id,
            image: currentImage.id,
          }, true);
        case 'webslider':
          return this.Routing.generate('api_get_webslider_image', {
            '_format': 'json',
            webSliderId: id,
          }, true);
        case 'webslider-background':
          return this.Routing.generate('api_get_webslider_image_background', {
            '_format': 'json',
            webSliderId: id,
          }, true);
        case 'webcontainer':
          return this.Routing.generate('api_get_webcontainer_image', {
            '_format': 'json',
            webContainerId: id,
          }, true);
      }
    }

    return false;
  }

  uploadImage(id, type, credentials) {
    let url;
    switch (type) {
      case 'activite':
        url = this.Routing.generate('api_post_activite_image', {'_format': 'json', 'activite': id}, true);
        break;
      case 'famille':
        url = this.Routing.generate('api_post_famille-produit_image', {
          '_format': 'json',
          'familleProduit': id
        }, true);
        break;
      case 'produit':
        url = this.Routing.generate('api_post_produit_image', {
          '_format': 'json',
          'produit': id
        }, true);
        break;
      case 'article':
        url = this.Routing.generate('api_post_article_image', {
          '_format': 'json',
          'article': id
        }, true);
        break;
    }

    return this.http
      .post(url, credentials, {headers: this.updateHeaders('upload')})
      .map(response => response);
  }

  deleteImage(id, type, image) {
    let url;
    switch (type) {
      case 'activite':
        url = this.Routing.generate('api_delete_activite_image', {
          '_format': 'json',
          'activite': id,
          'image': image
        }, true);
        break;
      case 'famille':
        url = this.Routing.generate('api_delete_famille-produit_image', {
          '_format': 'json',
          'familleProduit': id,
          'image': image
        }, true);
        break;
      case 'produit':
        url = this.Routing.generate('api_delete_produit_image', {
          '_format': 'json',
          'produit': id,
          'image': image
        }, true);
        break;
      case 'article':
        url = this.Routing.generate('api_delete_article_image', {
          '_format': 'json',
          'article': id,
          'image': image
        }, true);
        break;
    }

    return this.http
      .delete(url, {headers: this.updateHeaders()})
      .map(response => response);
  }

}



// WEBPACK FOOTER //
// ./src/shared/services/images.service.ts